module.exports = __webpack_public_path__ + "static/media/no-image.9a9fcbe1.jpg";